module.exports = __webpack_public_path__ + "distVue/img/huozhixian.10f74988.png";